import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state,  Alert,SharedAccountsService) {
        this.$state = $state;
        this.Alert = Alert;
		this.SharedAccountsService = SharedAccountsService;
    }

    $onInit() {
        if (!this.accounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();
        
    }

    delete() {
        
		const companyId= this.companyId;
        this.isSaving = true;
        this.SharedAccountsService
            .deleteBulkCompanyServiceAccounts({companyId}, this.st.selectedIds).$promise
            .then(() => {
                this.Alert('success', 'company.user-directories.directory-groups.all-accounts.delete.deleted');
                this.$state.go('^', {companyId: companyId}, { reload: true, inherit: false, notify: false });;
            })
			.catch((error) => { })
            .finally(() => {this.isSaving = false;});
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/delete/delete-accounts.controller.js